import Evo1 from "../../../../content/blog/evolutionary_strategies/applet.js";
import React from 'react';
export default {
  Evo1,
  React
};